import React, { Fragment } from 'react';;

import { formatCurrency } from '../../utils/currencyFormatter';

import style from './forwarderHeaderInvoiceBallance.module.css';

import ForwarderInvoiceBalance from '../../models/ForwarderGhaInvoiceBalance';

interface ForwarderHeaderInvoiceBalance {
  invoiceAllowed: boolean;
  balance: ForwarderInvoiceBalance;
  eWalletBalance: ForwarderInvoiceBalance;
  cssClassName?: string;
  walletAllowed: boolean;
};

const forwarderHeaderInvoiceBalance = (props: ForwarderHeaderInvoiceBalance) => {
  return (
    <Fragment>
      <div className={ props.cssClassName ? props.cssClassName : style.invoiceBallanceText } >
        { props.walletAllowed && 
          <Fragment>
            <span className={ style.accountType }>{'eWallet Balance'}:</span>
            <span className={ style.balance }>{ formatCurrency(props.eWalletBalance.balance, 2, '$') }</span>
          </Fragment>
        }
      </div>
      <div className={ props.cssClassName ? props.cssClassName : style.invoiceBallanceText } >
        { props.invoiceAllowed && 
          <Fragment>
            <span className={ style.accountType }>{ props.balance.accountType.charAt(0).toUpperCase() + props.balance.accountType.slice(1) }:</span>
            <span className={ style.balance }>{ formatCurrency(props.balance.balance, 2, '$') }</span>
          </Fragment>
        }
      </div>

    </Fragment>
   
  );
};

export default forwarderHeaderInvoiceBalance;